import styled from "styled-components";


export const Container = styled.div`
        min-height:  360px;
        display: flex;
        justify-content: center;
        align-items: center;


`;